import { fork } from 'redux-saga/effects';
import healthPlansSaga from 'modules/healthPlans/sagas';
import categoriesSaga from 'modules/categories/sagas';
import commonSaga from 'modules/common/sagas';

function* rootSaga() {
  yield fork(healthPlansSaga);
  yield fork(categoriesSaga);
  yield fork(commonSaga);
}

export default rootSaga;
